// Generated by ReScript, PLEASE EDIT WITH CARE


function getFareEstimateCardSelectedVersion(mobile) {
  return /* Test */0;
}

export {
  getFareEstimateCardSelectedVersion ,
}
/* No side effect */
